/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { StyleSheet, css } from 'aphrodite';

import { ApiHelper } from '../helpers/ApiHelper';
import { AppStyles, AppTheme } from '../../styles/AppTheme';
import { Helper } from '../helpers/Helper';
import { AppHelper } from '../../helpers/AppHelper';
import { BaseEntityPage } from './BaseEntityPage';
import { AppConfig } from '../../AppConfig';
import TableCard from './tables/TableCard';
import { FormControl, Grid, IconButton, TableCell, TextField } from '@material-ui/core';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import { StatCard } from './StatCard';
import { CRMHelper } from '../../helpers/CRMHelper';
import { CommonTheme } from '../../styles/Styles';
import { UiHelper } from '../helpers/UiHelper';
import { Controller } from '../Controller';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { SearchBar } from './SearchBar';
import { StaffHelper } from '../helpers/StaffHelper';

function getTableExportFieldDef(options) {
  const {orgId, teamSelected} = options
  function _getField(key, label, currentVal, currentLabel, placement, attribs = {}) {
    return {
      key,
      type: 'radio',
      label,
      options: [{key: currentVal, label: currentLabel}],
      v_required: {
        value: true,
        err: `Choose ${label}`,
      },
      placement,
      defaultValue: currentVal,
      ...attribs,
    }
  }

  let orgUnitId = orgId
  let teamLabel = 'All'
  if(teamSelected && teamSelected.key !== 'all') {
    orgUnitId = teamSelected.key
    teamLabel = teamSelected.label
  }

  const fieldDef = {
    title: Helper.getString('exportSummary'),
    ctaButtonText: 'Export',
    steps: [
      {
        fields: [
          _getField('orgUnitId', 'Team', orgUnitId, teamLabel, 'right'),
        ]
      }
    ],
    disableAlwaysFormFields: ['orgUnitId'],
  }
  return fieldDef
}

function aggregateReportData(data) {
  let totalDocCount = 0
  for (let i = 0; i < data.length; i++) {
    const item = data[i]

    if (item && typeof item.doc_count === 'number') {
      totalDocCount += item.doc_count
    }
  }

  const resultArray = [
    {
      key: 'TOTAL ASSIGNED',
      doc_count: totalDocCount
    },
    {
      key: 'TOTAL STAFF',
      doc_count: Array.isArray(data) ? data.length : 0
    }
  ]

  return resultArray
}

function generateStatsData(staff, orderedKeys = []) {
  let lookup = {}
  if((staff && staff.states && staff.states.buckets && staff.states.buckets.length > 0)) {
    lookup = staff.states.buckets.reduce((acc, item) => {
      acc[item.key] = item.doc_count
      return acc
    }, {})
  }

  if(staff.doc_count) {
    lookup.TOTAL = staff.doc_count
  }

  const statsData = {}

  orderedKeys.forEach((key) => {
    statsData[key] = lookup[key] || 0
  })

  return statsData
}

function generateContactAssignmentReport({contactAssignmentStats, teamSelected, orgId, staffUsers}) {
  if(!contactAssignmentStats || contactAssignmentStats.length === 0) {
    return {}
  }

  const keys = ['TOTAL','FOLLOWUPS OVERDUE','CUSTOMER', 'PROSPECT', 'NEW', 'OPEN', 'ATTEMPTED TO CONTACT', 'CONNECTED', 'IN PROGRESS', 'OPEN DEAL', 'BAD TIMING', 'LOST', 'UNQUALIFIED' ]
  let reportHeaders = ['STAFF', 'TOTAL','FOLLOWUPS OVERDUE','CUSTOMER', 'PROSPECT', 'NEW', 'OPEN', 'ATC', 'CONNECTED', 'IN PROGRESS', 'OPEN DEAL', 'BAD TIMING', 'LOST', 'UNQUALIFIED']
  reportHeaders = reportHeaders.map((reportHeader)=> UiHelper.renameCRMContactLeadStatus(orgId, reportHeader))
  const reportHeaderTooltips = ['STAFF', ...keys]
  const hiddenColumns = []
  const textColumnIndices = [0]
  const stickyColumnIndices = [0]

  const crmHiddenStatusesCdpSettings = AppHelper.getSetting(orgId, 'CRM_CONTACT_HIDE_STATUS')
  if (crmHiddenStatusesCdpSettings) {
    const hiddenSet = new Set(crmHiddenStatusesCdpSettings.split(',').map(item => item.trim()).filter(Boolean))
    reportHeaderTooltips.forEach((key, index) => {
      if (hiddenSet.has(key)) {
        hiddenColumns.push(index)
      }
    })
  }

  const data = contactAssignmentStats.map((staff)=>{
    if(staff) {
      return({
        data: {
          userId: staff.userId,
          name: staff.name,
          email: staff.email,
          phone: staff.phone,
          assigneeIdList: staff.assigneeIdList || []
        },
        ...generateStatsData(staff, keys),
      })
    }
  }).filter(a => !!a)


  return {
    headers: reportHeaders,
    headerTooltips: reportHeaderTooltips,
    rows: data.map(item => Object.values(item)),
    textColumnIndices: textColumnIndices,
    hiddenColumnIndices: hiddenColumns,
    stickyColumnIndices: stickyColumnIndices,
    renderCustomTableBody: (cellValue, columnIndex) => {
      if(columnIndex === 0) {
        const deletedUserName = '[Deleted User]'
        let urlPath = null
        if(teamSelected) {
          if(staffUsers && staffUsers.length > 0 && cellValue && cellValue.userId) {
            const matched = staffUsers.some((staff) => staff && staff.userId === cellValue.userId)
            if(!matched) {
              cellValue.name = deletedUserName
            }
          }
          if(cellValue && cellValue.userId) {
            if(teamSelected.key === 'all') {
              urlPath = `/admin/orgs/${orgId}/crm-contacts?assignee=${cellValue.userId}`
            } else {
              urlPath = `/admin/orgs/${orgId}/crm-contacts?assignee=${cellValue.userId}&subOrgId=${teamSelected.key}`
            }
          }

        }

        return(
          <TableCell key={columnIndex} className={css(Styles.cellBody, Styles.firstColumn, Styles.cellWidthNormal, (stickyColumnIndices.includes(columnIndex) && Styles.stickyColumn))}>
            <Tooltip
              title={(cellValue.name !== deletedUserName) ? (<div className={css(Styles.spanValue, Styles.infoCell, Styles.tooltip)}>
                {cellValue && cellValue.name && <span className={css(Styles.infoFieldTooltip)}><span className={css(Styles.infoFieldLabel)}>{'Name: '}</span>{cellValue.name}</span>}
                {cellValue && cellValue.email && <span className={css(Styles.infoFieldTooltip)}><span className={css(Styles.infoFieldLabel)}>{'Email:'}</span>{cellValue.email}</span>}
                {cellValue && cellValue.phone && (<span className={css(Styles.infoFieldTooltip)}><span className={css(Styles.infoFieldLabel)}>{'Phone:'}</span>{cellValue.phone}</span>)}
              </div>) : ''}
              placement='top'
              className={css(Styles.tooltip)}
            >
              <div className={css(Styles.spanValue, Styles.infoCell)}>
                {cellValue && (cellValue.name || cellValue.email || cellValue.phone) && <span className={css(Styles.infoField, urlPath && Styles.infoFieldHyperLink)} onClick={() => urlPath && window.open(urlPath , '_blank')}>{cellValue.name || cellValue.email || cellValue.phone}</span>}
              </div>
            </Tooltip>
          </TableCell>
        )
      }
      return null
    }
  }
}

export class StaffLoad extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.subOrgId = Controller.get().userMgr().getSubOrgId(this.orgId)
    this.teamsEnabled = AppHelper.isTeamsEnabled(this.orgId)
    this.pageTitle = Helper.getString('staff-assignments')
    this.pageKey = 'staff-assignments'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() }
    ]
    this.breadCrumbs.push({ title: this.pageTitle })
    this.toFetch = [
      { key: 'contactAssignmentReport', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-contact-assignment-report'], queryParams: { orgId: this.orgId, ...(this.subOrgId && {subOrgId: this.subOrgId}), orgUnitId: this.orgId } },
      { key: 'usersORG', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-org-users2'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId } },
    ]
    if (this.teamsEnabled) {
      this.toFetch.push({ key: 'suborgs', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-sub-orgs'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId } })
    }
    this.headerActions = [
      {
        label: Helper.getString('exportSummary'),
        tooltip: Helper.getString('exportSummary'),
        icon: 'download',
        type: 'icon-label',
        onClick: () => {
          const apiData = {
            tableExport: true
          }
          const fieldDef = getTableExportFieldDef({orgId: this.orgId, teamSelected: this.state.teamSelected})
          fieldDef.title = Helper.getString('exportSummary')
          this.openModalForAdd(fieldDef, apiData)
        }
      }
    ]

    this.emptyText = 'No report in this org yet!'
    this.apiData = {}
    this.teams = [
      {key: 'all', label: 'All'},
    ]
    this.team = this.teams[0]
    this.statusOptions = [
      { key: 'all', label: 'All' },
      { key: 'live', label: 'LIVE' },
      { key: 'disabled', label: 'DISABLED' },
    ]
    this.statusDefault = this.statusOptions[0]
    this.state.searchText = ''
  }

  onFetchSuccess(results) {
    this.fieldDef = results[0].fieldDef
    this.formDefinition = this.fieldDef
    this.staffUsers = this.getResult(results, 'usersORG').items


    const teams = [...this.teams]
    if (this.teamsEnabled) {
      this.subOrgs = this.getResult(results, 'suborgs') ? this.getResult(results, 'suborgs').items : []
      if(this.subOrgs && this.subOrgs.length > 0) {
        for (const d of this.subOrgs) {
          teams.push({
            key: d.id || d.userId,
            label: d.title
          })
        }
      }
    }

    const contactAssignmentReport = this.getResult(results, 'contactAssignmentReport')

    this.setState({
      statsContactAssignment: contactAssignmentReport && contactAssignmentReport.statsContactAssignment,
      statsContactAssignmentMasterList: contactAssignmentReport && contactAssignmentReport.statsContactAssignment,
      teamSelected: (this.teams && this.teams.length > 0 ) && this.teams.find(option => option.key === this.team.key),
      teams: teams,
    })
  }

  openModalForAdd(fieldDef, apiData = {}) {
    this.apiData = {
      orgId: this.orgId,
      ...apiData,
    }

    let fieldDefinition = null
    if(fieldDef) {
      fieldDefinition = JSON.parse(JSON.stringify(fieldDef))
    }

    super.openModalForAdd(fieldDefinition)
  }

  renderAggregatedStats() {
    if(Array.isArray(this.state.statsContactAssignment) && this.state.statsContactAssignment.length > 0) {
      let cardsData = []

      const aggregatedData = aggregateReportData(this.state.statsContactAssignment)

      aggregatedData.forEach((card, i) => {
        cardsData.push({
          key: card.key,
          text: card.doc_count || 0,
          subText: card.key,
          cardIndex: i + 2,
          cardId: card.key,
          padding: 'small'
        })
      })

      const maxCardsPerRow = 7
      cardsData = CRMHelper.splitCardsIntoBalancedRows(cardsData, maxCardsPerRow)
      if(cardsData && cardsData.length > 0) {
        return(<div className={css(Styles.tableStatItem)}>
          {((!this.isMobileView) && cardsData && cardsData.length > 0) && (<div className={css(Styles.numericStatItemRow)}>
            {cardsData.map((row)=>(<Grid container className={css(Styles.numericStatContainerRow)}>
              {row.map((card)=>(
                <StatCard
                  xs={4}
                  sm={1}
                  key={card.key}
                  text={card.text}
                  subText={card.subText}
                  cardIndex={card.cardIndex}
                  padding={card.padding}
                  cardId={card.cardId}
                  handleCardClick={card.handleCardClick}
                  containerStyle={Styles.statsCardContainer}
                  cardStyle={Styles.statsCard}
                />))}
            </Grid>))}
          </div>)}
          {((this.isMobileView)) && cardsData && cardsData.length > 0 && (<div className={css(Styles.numericStatItemRow)}>
            {cardsData.map((row, index) => {
              const rowGroups = Array.from({ length: Math.ceil(row.length / 3) })
              return (
                <Grid key={index}>
                  {rowGroups.map((_, groupIndex) => {
                    const groupItems = row.slice(groupIndex * 3, groupIndex * 3 + 3)
                    return (
                      <Grid
                        key={groupIndex}
                        container
                        className={css(Styles.numericStatContainerRow)}
                      >
                        {groupItems.map((card) => (
                          <StatCard
                            xs={12 / groupItems.length}
                            sm={12 / groupItems.length}
                            key={card.key}
                            text={card.text}
                            subText={card.subText}
                            cardIndex={card.cardIndex}
                            padding={card.padding}
                            cardId={card.cardId}
                            handleCardClick={card.handleCardClick}
                            containerStyle={Styles.statsCardContainer}
                            cardStyle={Styles.statsCard}
                          />
                        ))}
                      </Grid>
                    )
                  })}
                </Grid>
              )
            })}
          </div>)}
        </div>)
      }
    }
    return null
  }

  filterStaffByStatus(items, statusSelected) {
    const selectedStatus = statusSelected || this.state.statusSelected || this.statusDefault
    if(!selectedStatus || selectedStatus.key === 'all') {
      return items
    }
    const status = selectedStatus.key.toUpperCase()
    return (items || []).filter(item => {
      if(item && item.userId) {
        const staffUser = this.staffUsers && this.staffUsers.find(user => user.userId === item.userId)
        return staffUser && staffUser.state === status
      }
      return false
    })
  }

  async reFetchReport({orgUnitId = this.orgId}) {
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
      customError: null,
    })

    ApiHelper.callAwait({
      method: 'GET',
      endPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'get-contact-assignment-report'],
        queryParams: { orgId: this.orgId, ...(this.subOrgId && {subOrgId: this.subOrgId}), orgUnitId},
      })
    }).then(response => {
      if(response) {
        const statsContactAssignmentMasterList = response && response.statsContactAssignment
        let statsContactAssignment = this.filterStaffByStatus(statsContactAssignmentMasterList)
        if(this.state.searchText) {
          statsContactAssignment = StaffHelper.searchOnUserList(statsContactAssignment, this.state.searchText)
        }
        this.setState({
          statsContactAssignment: statsContactAssignment,
          statsContactAssignmentMasterList: statsContactAssignmentMasterList,
          fetchState: ApiHelper.State.READY,
          loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
        })
      }
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      this.setState({
        customError: errorMessage,
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
      })
    })

  }

  onTeamsAutoCompleteChange = (value) => {
    if(value && value.key) {
      this.setState({
        teamSelected: value,
      }, ()=> {
        this.reFetchReport({orgUnitId: value.key === 'all' ? this.orgId : value.key})
      })
    }
  }

  onStatusAutoCompleteChange = (value) => {
    if(value && value.key) {
      let filteredItems = this.filterStaffByStatus(this.state.statsContactAssignmentMasterList, value)

      if(this.state.searchText) {
        filteredItems = StaffHelper.searchOnUserList(filteredItems, this.state.searchText)
      }

      this.setState({
        statusSelected: value,
        statsContactAssignment: filteredItems
      })
    }
  }

  renderFilters() {
    return (<div className={css(Styles.filterContainer)}>
      {this.teamsEnabled && (
        <>
        <div className={css(Styles.formControlContainer)}>
          <p className={css(Styles.label)}>{'Team'}</p>
          <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
            <Autocomplete
              value={this.state.teamSelected || this.team}
              options={this.state.teams || this.teams}
              onChange={(e, val) => this.onTeamsAutoCompleteChange(val)}
              getOptionLabel={(option) => option.label || option.text}
              getOptionSelected={(option, value) => option.key === value.key}
              disableClearable
              forcePopupIcon={this.state.teams.length > 1}
              popupIcon={this.state.teams.length > 1 ? undefined : null}
              open={this.state.teams.length > 1 ? undefined : false}
              renderInput={params =>
                <TextField
                  {...params}
                  variant={'standard'}
                  className={css(Styles.formControlFilters)}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    readOnly: true,
                    classes: {
                      root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                      input: css(Styles.formInputStyle, Styles.textInput),
                    },
                  }} />}
            />
          </FormControl>
        </div>
        <div className={css(Styles.formControlContainer)}>
          <p className={css(Styles.label)}>{'Status'}</p>
          <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
            <Autocomplete
              value={this.state.statusSelected || this.statusDefault}
              options={this.statusOptions}
              onChange={(e, val) => this.onStatusAutoCompleteChange(val)}
              getOptionLabel={(option) => option.label || option.text}
              getOptionSelected={(option, value) => option.key === value.key}
              disableClearable
              renderInput={params =>
                <TextField
                  {...params}
                  variant={'standard'}
                  className={css(Styles.formControlFilters)}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    readOnly: true,
                    classes: {
                      root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                      input: css(Styles.formInputStyle, Styles.textInput),
                    },
                  }} />}
            />
          </FormControl>
        </div>
      </>
      )}
    </div>
    )
  }

  handleRefreshButtonClick () {
    this.fetchItems()
  }

  onSearch(searchText = '') {
    let filteredItems = this.filterStaffByStatus(this.state.statsContactAssignmentMasterList)
    if(searchText) {
      filteredItems = StaffHelper.searchOnUserList(filteredItems, searchText)
    }

    this.setState({
      searchText: searchText,
      statsContactAssignment: filteredItems
    })
  }

  clearSearch() {
    this.setState({
      searchText: '',
      teamSelected: this.team,
      statusSelected: this.statusDefault,
      statsContactAssignment: this.state.statsContactAssignmentMasterList
    }, ()=>{
      this.reFetchReport({orgUnitId: this.orgId})
    })
  }

  renderSearchBar() {
    return(<div className={css(Styles.searchBarContainer)} onSubmit={(e) => e.preventDefault()}>
      <SearchBar
        hint={Helper.getString('staffSearchHint')}
        onSearch={this.onSearch.bind(this)}
        onClearSearch={this.clearSearch.bind(this)}
        searchText={this.state.searchText}
        searchButtonLabel='Filter'
        clearSearchLabel='Clear'
        autoRefresh={true}
        debounceDuration={1}
        autoFocus={true}
        hideFiltersContainer={true}
      >
      </SearchBar>
    </div>)
  }

  renderBelowTable() {
    if(this.state.customError && this.state.customError.errMsg) {
      const errorDetails = {
        image: require('../../assets/images/empty.svg'),
        message: this.state.customError.errMsg || Helper.getString('staffActivityReportNotAvailable'),
        buttonText: 'Refresh',
        action: this.handleRefreshButtonClick.bind(this),
      }

      return(
        <div className={css(Styles.outerContainer)}>
          <div className={css(Styles.reportDashboardContainer)}>
            {this.renderFilters()}
            <div className={css(Styles.reportsContainer, Styles.reportsDataContainer)}>
              {UiHelper.customErrorViewWithRefresh(errorDetails)}
            </div>
          </div>
        </div>
      )
    }

    const report = this.state.statsContactAssignment && generateContactAssignmentReport({contactAssignmentStats: this.state.statsContactAssignment, teamSelected: this.state.teamSelected, orgId: this.orgId, staffUsers: this.staffUsers})
    let cellWidths = {}
    if(report && report.headers) {
      cellWidths  = Object.fromEntries(report.headers.map(header => [header, Styles.headerCell]))
    }

    return(
      <div className={css(Styles.outerContainer)}>
        <div className={css(Styles.reportDashboardContainer)}>
          <div className={css(Styles.reportsContainer, Styles.reportsDataContainer)}>
            {this.renderFilters()}
            {this.renderAggregatedStats()}
            {this.renderSearchBar()}
            <div className={css(Styles.tableStatItem)}>
              <TableCard
                item={{data: report || {},  maxRows: 100}}
                showMoreInTable={true}
                cellWidths={cellWidths}/>
            </div>
          </div>
        </div>
      </div>
    )
  }

  async customSubmitForTableExport(options) {
    const { formType, formData, caller } = options
    delete formData.tableExport
    ApiHelper.callAwait({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'export-staff-load-report'],
        queryParams: {orgId: this.orgId, ...(this.subOrgId && {subOrgId: this.subOrgId})},
      }),
      jsonBody: { orgUnitId: formData.orgUnitId}
    }).then(response => {
      window.open(this.baseRoute() + '/jobscrm', '_self')
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }

  async customSubmit(options) {
    const { formType, formData, caller } = options
    if (formData.tableExport) { return this.customSubmitForTableExport(options) }
    return caller.submit.call(caller, formData, true);
  }

}

export const Styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',

  },
  reportDashboardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    maxWidth: AppTheme.viewPort,
    overflow: 'hidden',
    marginBottom: 20,
    '@media (max-width: 1024px)': {
      gap: 0,
    }
  },
  reportsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 10,
  },
  reportsDataContainer: {
    justifyContent: 'center',
    '@media (max-width: 1024px)': {
      maxWidth: '96vw'
    }
  },
  tableStatItem: {
    flex: 1,
    minWidth: '100%',
    height: '100%',
    maxWidth: window.innerWidth - AppTheme.drawerWidth - (AppTheme.adminPagePadding * 2),
    '@media (max-width: 767px)': {
      width: '100%',
      alignSelf: 'center',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
  },
  cellBody: {
    backgroundColor: 'white',
    color: CommonTheme.textColor,
    // minHeight: 72,
    borderBottom: '1px solid ' + AppTheme.borderColor,
    fontSize: 16,
    textAlign: 'center',
    padding: '16px 5px',
    verticalAlign: 'middle',
    wordBreak: 'break-all',

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
    minWidth: 0,

    '@media (max-width: 767px)': {
      fontSize: 10,
      padding: '16px 2px',
    },
  },
  firstColumn: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    // overflowX: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
    '@media(max-width: 767px)': {
      maxWidth: 'unset',
      whiteSpace: 'unset',
    }
  },
  spanValue: {
    fontSize: 14
  },
  infoCell: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 2,
    fontSize: 16,
    minWidth: 0,
  },
  infoFieldTooltip: {
    display: 'block',
  },
  infoField: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 180,
  },
  infoFieldHyperLink: {
    color: AppTheme.primaryColor,
    cursor: 'pointer'
  },
  numericStatItemRow: {
    '@media (max-width: 1024px)': {
      alignSelf: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      height: '100%',
    },
    width: '100%',
  },
  numericStatContainerRow: {
    height: '100%',
    maxHeight: '100%',
    maxWidth: AppTheme.viewPort,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2px 0px 0px 0px',
    margin: 0,
    gap: 5,
    //justifyContent: 'left',
    '@media (max-width: 1024px)': {
      padding: '2px 0px',
      gap: 0
    },
  },
  statsCardContainer: {
    maxWidth: 'unset',
    flex: 1,
  },
  statsCard: {
    width: '100%'
  },
  filterContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
    '@media (max-width: 1024px)': {
      paddingTop: 5
    },
  },
  formControlContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5,
  },
  label: {
    fontSize: 14,
    color: CommonTheme.subTextColor,
    margin: 0,
    display: 'inline-block'
  },
  infoFieldLabel: {
    fontWeight: 500,
    display: 'inline-block',
    marginRight: 5,
  },
  formControlMainFilters: {
    width: 240,
    '@media (max-width: 1024px)': {
      width: '100%',
      alignSelf: 'center',
    },
  },
  formControlFilters: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden'
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16
  },
  autoCompleteInputRoot: {
    paddingRight: 48,
    '@media (max-width: 440px)': {
      paddingRight: 18,
    },
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  textInput: {
    padding: '4px 0px',
    '@media (max-width: 440px)': {
      fontSize: 12,
    },
  },
  displayFieldStyle: {
    '@media (max-width: 1024px)': {
      width: '100%',
    },
  },
  headerCell: {
    minWidth: 80,
  },
  tooltip: {
    fontSize: 12
  },
  cellWidthSmall: {
    width: '10%',
    padding: '8px 5px',
  },
  cellWidthNormal: {
    width: '20%',
    padding: '8px 5px',
  },
  cellWidthMedium: {
    width: '30%',
    padding: '8px 5px',
  },
  cellWidthWide: {
    width: '50%',
    padding: '8px 5px',
  },
  searchBarContainer: {
    width: '100%'
  },
  stickyColumn: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    backgroundColor: 'white',
  },
})